import { render, staticRenderFns } from "./GptPlayground.vue?vue&type=template&id=b504c99a&scoped=true"
import script from "./GptPlayground.vue?vue&type=script&lang=js"
export * from "./GptPlayground.vue?vue&type=script&lang=js"
import style0 from "./GptPlayground.vue?vue&type=style&index=0&id=b504c99a&prod&scoped=true&lang=css"
import style1 from "./GptPlayground.vue?vue&type=style&index=1&id=b504c99a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-load_f5b883aeb3d125b1f29ae1b8ca7c56aa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b504c99a",
  null
  
)

export default component.exports